import { createTheme } from "@mui/material";

export const theme = createTheme({
  typography: {
    fontFamily: "Noto Sans Bengali", 
  },
  palette: {
    primary: {
      main: "#5bc1ac",
    },
    success: {
      main: "#004225",
    },
    warning: {
      main: "#FFB000",
    },
    info: {
      main: "#6499E9",
    },
    light: {
      main: "#F1EFEF",
    },
    danger: {
      main: "#D71313",
    },
    secondary: {
      main: "#ff0000",
    },
    otherColor: {
      main: "#06283D",
      light: "#f1f1f1",
    },
    activeColor: "#fff",
    boxShadow: "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
  },
});
